import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbClassDto} from "../model/QbClassDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbClassSelectController implements IComponentController {
    records: QbClassDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbClass(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbClassSubscribeAndQuery().then(ret=>this.records=ret);
    };

    $onInit(): void {
    }
    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbClassSelect', [])
    .component('qbClassSelect', {
        template: require('./QbClassSelect.html'),
        controller: QbClassSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
